<template>
  <a-modal :title="`【${user.name}】的许愿池`"
           :width="700"
           :open="modal"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <a-select :options="albumList"
                v-model:value="albumId"
                size="small"
                @change="query"/>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :data-source="source"
             :loading="loading"
             :pagination="false"
             :scroll="{ y: 611 }">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'thumbnail'">
          <a-image :src="record.thumbnail" :height="30"/>
        </template>

        <template v-else-if="column.dataIndex === 'state'">
          <a-tag v-if="record.state === 0" :bordered="false" color="red">失效</a-tag>
          <a-tag v-else-if="record.state === 1" :bordered="false" color="orange">许愿中</a-tag>
          <a-tag v-else :bordered="false" color="green">达成</a-tag>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

const albumId = ref(0)

const source = ref([])

const user = ref({})

const modal = ref(false)
const loading = ref(false)

const columns = [
  {
    key: 'name',
    title: '名称',
    dataIndex: 'name',
  }, {
    key: 'thumbnail',
    title: '缩略图',
    dataIndex: 'thumbnail',
  }, {
    key: 'state',
    title: '状态',
    dataIndex: 'state',
  }, {
    key: 'createTime',
    title: '许愿时间',
    dataIndex: 'createTime',
  }, {
    key: 'updateTime',
    title: '实现时间',
    dataIndex: 'updateTime',
  },
]

let albumList = []

function query() {
  loading.value = true

  axios.get(`/user/${user.value.id}/wish/${albumId.value}`,).then((res) => {
    loading.value = false

    if (res.code === 1) {
      source.value = res.data
    }

    modal.value = true
  })
}

function album() {
  axios.get('/album-opt').then((res) => {
    if (res.code === 1) {
      albumList = res.data
      if (albumList.length) {
        albumId.value = albumList[0].value
      }
      query()
    }
  })
}

function openCk(record) {
  user.value = record
  album()
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>